module.exports = __webpack_public_path__ + "img/harvest-apple-cake.3cb693c7.jpg";